import { render, staticRenderFns } from "./ApplicationsPage.vue?vue&type=template&id=d64f81c0"
import script from "./ApplicationsPage.vue?vue&type=script&lang=js"
export * from "./ApplicationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports